import { render, staticRenderFns } from "./AdministratorSchedule.vue?vue&type=template&id=6b063693&scoped=true"
import script from "./AdministratorSchedule.vue?vue&type=script&lang=js"
export * from "./AdministratorSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b063693",
  null
  
)

export default component.exports